import { Routes } from "@angular/router";

export const ROUTES: Routes = [
  {
    path: "",
    redirectTo: "chat",
    pathMatch: "full",
  },
  {
    path: "chat",
    loadComponent: () =>
      import("./features/chat/pages/chat/chat.component").then(
        (m) => m.ChatComponent
      ),
  },
  {
    path: "pravila-uporabe",
    loadComponent: () =>
      import("./features/terms-of-use/terms-of-use.component").then(
        (m) => m.TermsOfUseComponent
      ),
    data: {
      title: "Pravila uporabe",
      breadcrumb: "Pravila uporabe",
    },
  },
  {
    path: "error",
    loadComponent: () =>
      import("./features/error-page/error/error.component").then(
        (m) => m.ErrorComponent
      ),
    data: {
      title: "Error Page",
      breadcrumb: "Error Page",
    },
  },
  {
    path: "**",
    redirectTo: "chat",
  },
];
